import loadable from '../../shared/utils/loadable';

// Code splitting!

const App = loadable(() => import('../App'));

const UserProfile = loadable(() => import('../containers/UserProfile'));

const routes = [{
	path: '/members',
	component: App,
	routes: [{
		path: '/members/:slug',
		component: UserProfile,
	}]
}];

export default routes;
